import Ballpit from "./Ballpit";

const App1 = () => {
  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        minHeight: "1000px",
        maxHeight: "1000px",
        width: "100%",
      }}
    >
      <Ballpit
        count={400}
        gravity={1}
        friction={1}
        wallBounce={0.95}
        followCursor={false}
        colors={["#FFF"]}
        maxVelocity={1}
        lightIntensity={0}
      />
    </div>
  );
};

export default App1;
